import {NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {InfraModule} from 'ac-infra';
import {FlexModule} from '@angular/flex-layout';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {HttpApiInterceptorService} from './interceptors/http-api-interceptor/http-api-interceptor.service';
import {HttpLoaderInterceptorService} from './interceptors/http-loader-interceptor/http-loader-interceptor.service';
import {HttpErrorInterceptorService} from './interceptors/http-error-interceptor/http-error-interceptor.service';
import {ArmUrlSerializerService} from './services/common/arm-url-serializer/arm-url-serializer.service';
import {NetworkModule} from './network/network.module';
import {DialogsModule} from './dialogs/dialogs.module';
import {ArmModule} from './arm/arm.module';
import {RouterModule, UrlSerializer} from '@angular/router';
import {SettingsModule} from './settings/settings.module';
import {UsersModule} from './users/users.module';
import {RoutingModule} from './routing/routing.module';
import {LoaderModule} from './components/loader/loader.module';
import {LoginModule} from './login/login.module';
import {AppRoutingModule} from './app-routing.module';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MAT_SELECT_CONFIG} from '@angular/material/select';
import {MAT_DIALOG_DEFAULT_OPTIONS} from '@angular/material/dialog';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field';
import {AlarmsModule} from './alarms/alarms.module';
import {StatisticsModule} from './statistics/statistics.module';
import {DatePipe} from '@angular/common';
import {InfoWrappersModule} from './utils/info-wrappers/info-wrappers.module';
import {MaterialModule} from './material.module';
import {AzureResolver} from './login/azure-resolver';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {DashboardModule} from './dashboard/dashboard.module';
import {CallsModule} from './calls/calls.module';
import {APP_INITIALIZER} from '@angular/core';
import {initializeApp} from './services/common/user-data/user-data-initializer';
import {UserDataService} from './services/common/user-data/user-data.service';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    AppRoutingModule,
    ArmModule,
    DialogsModule,
    NetworkModule,
    RoutingModule,
    SettingsModule,
    UsersModule,
    InfraModule.forRoot(),
    RouterModule,
    FlexModule,
    LoaderModule,
    LoginModule,
    MatSnackBarModule,
    AlarmsModule,
    StatisticsModule,
    CallsModule,
    InfoWrappersModule,
    DashboardModule,
    MaterialModule,
    BrowserModule,
    BrowserAnimationsModule,
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: HttpApiInterceptorService, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: HttpLoaderInterceptorService, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptorService, multi: true},
    {provide: UrlSerializer, useClass: ArmUrlSerializerService},
    {provide: MAT_SELECT_CONFIG, useValue: {disableOptionCentering: true}},
    {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {disableClose: true, hasBackdrop: true}},
    DatePipe,
    AzureResolver,
    UserDataService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [UserDataService],
      multi: true,
    },
    {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {floatLabel: 'always'}}
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule {
}

